var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsUnsnoozeEnabled24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.324 2.4a.75.75 0 0 1-.104 1.055l-2.805 2.3-1.282-.888 3.135-2.572a.75.75 0 0 1 1.056.104Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.43 5.584a.5.5 0 0 0-.369.903l2.334 1.624a9 9 0 0 0 14.76 10.266l2.213 1.538a.5.5 0 1 0 .57-.82l-.177-.124a.499.499 0 0 1-.113-.059L2.506 5.65a.503.503 0 0 1-.077-.065Zm3.198 3.384a7.5 7.5 0 0 0 12.293 8.55l-5.56-3.867-1.228 1.474H14.2a.75.75 0 0 1 0 1.5H9.532a.75.75 0 0 1-.576-1.23l2.17-2.604-5.498-3.823Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.188 16.684A9 9 0 0 0 5.602 6.578l1.254.869a7.5 7.5 0 0 1 12.077 8.368l1.255.87Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m13.624 12.136 1.484-1.78a.75.75 0 0 0-.576-1.231h-4.78a.747.747 0 0 0-.35.086l2.042 1.414h1.487l-.545.653 1.238.858Zm3.22-8.681a.75.75 0 1 1 .951-1.16l3.213 2.635a.75.75 0 0 1-.952 1.16l-3.212-2.635Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsUnsnoozeEnabled24);
export default __webpack_public_path__ + "static/media/actions-unsnooze-enabled-24.dda94b12a7218707cf0e689337252898.svg";
export { ForwardRef as ReactComponent };